import { CopilotServiceApplication } from "@/application/copilot-service-application";
import globals from "./globals";
import { CopilotService } from "@/domain/copilot-service";
import { EventAggregationService } from "./event-aggregation-service";
import { CopilotServiceReadyEvent } from "interfaces";

export class RenderCopilotService {
	public static renderCopilotApplication(): void{
		const application = new CopilotServiceApplication(new CopilotService());
		globals.application = application;
		EventAggregationService.instance?.publishTo(CopilotServiceReadyEvent.EventType, new CopilotServiceReadyEvent(globals.application));
	}
}